const headRowsTableActions = {
  id: 'ID',
  sponsor: 'Responsáveis',
  createdAt: 'Criada em',
  deadline: 'Prazo',
  equipment: 'Equipamento',
  itemVerification: 'Verificação',
  place: 'Local',
  status: 'Status',
  action: 'Ação',
};

export default headRowsTableActions;
